<script setup lang="ts">
/**
 * AppBackdrop (затемнение) для overlay элементов на mobile
 */
interface Props {
  show?: boolean;
  zIndex?: number;
  position?: 'fixed' | 'absolute';
}

withDefaults(defineProps<Props>(), {
  show: false,
  zIndex: 1040,
  position: 'fixed',
});

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  emit('click');
};
</script>

<template>
  <Transition name="backdrop">
    <div
      v-if="show"
      class="backdrop"
      :class="{ 'backdrop--absolute': position === 'absolute' }"
      :style="{ zIndex }"
      @click="handleClick"
    />
  </Transition>
</template>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.backdrop--absolute {
  position: absolute;
}

/* Анимация появления/исчезновения */
.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity var(--sidebar-transition-duration) ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

.backdrop-enter-to,
.backdrop-leave-from {
  opacity: 1;
}
</style>
